module.exports = __webpack_public_path__ + "static/personal_data_processing_policy-ef7e2d994d62dc8173f73df2fa6bfad8.pdf";